export default {
  title: 'Learners',
  empty: 'No learners found!',
  empty_cta: 'Create',
  empty_cta_import: 'Import Learner!',
  table: {
    learner_details: 'Learner Details',
    company: 'Company Name',
    created_at: 'Created At',
    joined_at: 'Joined At',
    last_accessed: 'Last Accessed',
    actions: 'Actions',
    footer_display: `Showing %{min_count} - %{max_count} of %{count}`
  },
  sort_by: {
    created_at: 'Created At',
    last_accessed_at: 'Last Accessed At'
  },
  button: {
    create: 'Create',
    add: 'Add',
    add_or_import: 'Add / Import',
    upload: 'Upload'
  },
  create: {
    title: 'Create learner',
    email: 'Email',
    first_name: 'First Name',
    last_name: 'Last Name',
    company: 'Company'
  },
  import: {
    title: 'Bulk import learners',
    desc: 'Bulk import learners into Trainn',
    file_upload_label: "Upload learner's csv",
    download_sample: 'Download sample csv',
    detailed_log: 'for detailed error log',
    click: 'Click here',
    loading:
      'Your data is being uploaded. This might take few seconds. Please wait...',
    success: `%{count} record(s) have been inserted successfully`,
    error: `Error %{message} in %{count} record(s)`,
    note: `Note: Your CSV data file should contain all the columns specific to the operation you are performing. The sample CSV file has most of the columns required for the operation.`
  },
  detail: {
    title: 'Learner Details',
    name: 'Name',
    email: 'Email',
    company: 'Company Name',
    created_at: 'Created At',
    joined_at: 'Joined At',
    last_accessed: 'Last Accessed At',
    nav: `Showing %{min_count} of %{max_count}`,
    user_properties: {
      title: 'User Engagements',
      engagement_time: 'Total engagement time',
      engagement_videos: 'Total video views'
    },
    activity: {
      title: 'Activity Log',
      created_at: 'Created at %{date}',
      joined_at: 'Joined on %{date}',
      last_accessed: 'Last accessed at %{date}'
    },
    analytics: {
      engaged_videos: {
        title: 'Engaged Videos',
        no_of_visits: 'Number of views',
        duration_spent: 'Engagement Time',
        empty: 'No video visits'
      },
      engaged_flows: {
        title: 'Engaged Flows',
        no_of_visits: 'Number of Visits',
        duration_spent: 'Engagement Time',
        empty: 'No flows learned yet',
        contains: 'Contains'
      }
    },
    back: 'Back to Learners'
  },
  actions: {
    invite_user: {
      title: 'Invite Learner to Hub',
      desc:
        'A link will be sent via email, through which the learner can login to your video hub'
    },
    share_hub_url: {
      title: 'Copy Hub Url',
      desc:
        'Unique video hub url that will associate engagements with this learner'
    },
    share_video: {
      title: 'Share a video',
      desc:
        'Share a video using a unique URL and track engagements specific to this learner',
      desc_long:
        'Share a video with this learner using a unique URL. This helps you to track engagements specific to this learner.',
      note:
        'This unique url only helps us to track engagements and does not authenticate the learner.',
      select: 'Select Video',
      copy: 'Copy Shareable Link'
    },
    share_collection: {
      title: 'Share a learning path',
      desc:
        'Share a learning path using a unique URL and track engagements specific to this learner',
      desc_long:
        'Share a learning path with this learner using a unique URL. This helps you to track engagements specific to this learner.',
      note:
        'This unique url is only for tracking engagements and does not authenticate the learner.',
      select: 'Select learning path',
      copy: 'Copy Shareable Link'
    },
    create: 'Create New Learner',
    edit: 'Edit Learner',
    delete: {
      title: 'Delete Learner',
      desc:
        'The learner will be deleted permanantly. Any links or reference to this learner will also be deleted.'
    }
  }
};
